<span nz-icon>
  <svg [attr.width]="size" [attr.height]="size" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17 9.17a1 1 0 0 0-1.41 0L12 12.71 8.46 9.17a1 1 0 1 0-1.41 1.42l4.24 4.24a.999.999 0 0 0 1.42 0L17 10.59a1 1 0 0 0 0-1.42Z"
      fill="currentColor"
    />
  </svg>
</span>
